import type {Nullable} from './utility-types';

export function openUrlInANewTab(
  url?: Nullable<string>,
  target: '_blank' | '_parent' | '_self' | '_top' = '_blank',
) {
  if (url) {
    return window.open(url, target);
  }
}
